// utils/authSession.js
//
// Ondersteunt de "Inloggen als"-functie in Admin.js (klik op een gebruiker in
// het beheerpaneel > open diens dashboard in een nieuw tabblad, alsof je als
// die gebruiker bent ingelogd). De impersonatie-token/gebruiker worden
// bewust in sessionStorage gezet i.p.v. het gewone localStorage:
// localStorage wordt gedeeld tussen ALLE tabbladen van dezelfde origin, dus
// als we daar de token van de andere gebruiker in zouden zetten, zou dat ook
// de echte, lopende sessie van de admin in diens eigen (originele) tabblad
// stiekem overschrijven. sessionStorage is daarentegen uniek per tabblad -
// het nieuwe tabblad krijgt zo een volledig geïsoleerde sessie, en de admin
// z'n eigen tabblad blijft gewoon ingelogd als admin.
//
// getAuthToken()/getAuthUser() geven voorrang aan die sessionStorage-waarden;
// bestaat er geen impersonatie-sessie in dit tabblad, dan valt dit gewoon
// terug op het normale, gedeelde localStorage - exact het gedrag van voor
// deze functie bestond.
const IMPERSONATION_TOKEN_KEY = 'impersonationToken';
const IMPERSONATION_USER_KEY = 'impersonationUser';

export const getAuthToken = () =>
  sessionStorage.getItem(IMPERSONATION_TOKEN_KEY) || localStorage.getItem('token');

export const getAuthUser = () =>
  sessionStorage.getItem(IMPERSONATION_USER_KEY) || localStorage.getItem('user');

export const isImpersonating = () =>
  sessionStorage.getItem(IMPERSONATION_TOKEN_KEY) !== null;

export const startImpersonating = (token, userJson) => {
  sessionStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
  sessionStorage.setItem(IMPERSONATION_USER_KEY, userJson);
};

export const stopImpersonating = () => {
  sessionStorage.removeItem(IMPERSONATION_TOKEN_KEY);
  sessionStorage.removeItem(IMPERSONATION_USER_KEY);
};
